import { render, staticRenderFns } from "./Trabajador.vue?vue&type=template&id=478820b9&"
import script from "./Trabajador.vue?vue&type=script&lang=js&"
export * from "./Trabajador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports